import { createContext } from 'react'

type PermissionContextType = {
    isAllowedTo: (permission: string[]) => { [key: string]: boolean } | null
}

const defaultContext: PermissionContextType = {
    isAllowedTo: () => null,
}

const PermissionsContext = createContext(defaultContext)

export default PermissionsContext
